var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 342,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_28521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00001 3L3 338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.75 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5 3V338.6",
    stroke: "#CBD5E1",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_28521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsPattern);
export default __webpack_public_path__ + "static/media/dots-pattern.2b1b2aa1a6876ac6ce727c050a3c83c5.svg";
export { ForwardRef as ReactComponent };